import { render, staticRenderFns } from "./ProcessNewThesis.vue?vue&type=template&id=29023702&scoped=true"
import script from "./ProcessNewThesis.vue?vue&type=script&lang=js"
export * from "./ProcessNewThesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29023702",
  null
  
)

export default component.exports